import _asyncToGenerator from '@babel/runtime/helpers/asyncToGenerator';
import _regeneratorRuntime from '@babel/runtime/regenerator';
import { fetchFileMetadata, getSecureTeam, getSecureStatus, batchProgress, moveFile, checkteamCreator } from '@kso/ui/lib/request';
import { subFileName, getFileIcon } from '@kso/util';
import Finder from '@kso/ui/lib/Finder';
import '@kso/ui/lib/Finder/style.css';
import Message from 'element-ui/lib/message';
import 'element-ui/lib/theme-chalk/message.css';
import merge from 'lodash/merge';
import { t } from '@kso/ui/lib/config/locale';

var FileMove = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', [_c('k-finder', {
      attrs: {
        "okText": _vm.lang_txt0,
        "isSelectFile": false,
        "committing": _vm.processing,
        "limitedCompany": _vm.limitedCompany,
        "limitedTabs": _vm.limitedTabs,
        "initSource": _vm.initSource
      },
      on: {
        "onClose": _vm.onClose,
        "onSubmit": _vm.onSubmit
      }
    })], 1);
  },
  staticRenderFns: [],
  name: 'KFileMove',
  components: {
    KFinder: Finder
  },
  props: {
    id: {
      type: Array,
      required: true
    },
    limitedCompany: {
      type: Object,
      "default": function _default() {
        return {};
      }
    },
    secureTeam: {
      type: Boolean,
      required: false
    },
    hasFolder: {
      type: Boolean,
      required: false
    },
    limitedTabs: {
      type: Array,
      "default": function _default() {
        return [];
      }
    },
    initSource: {
      type: Object,
      "default": function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      lang_txt0: t('logic.FileMove.txt0'),
      metadata: {},
      processing: false
    };
  },
  computed: {
    fname: function fname() {
      if (this.id.length > 1) {
        return '';
      }
      return this.metadata.fname || '';
    },
    title: function title() {
      if (this.id.length > 1) {
        return "".concat(t('logic.FileMove.txt1')).concat(this.id.length).concat(t('logic.FileMove.txt2'));
      }
      return this.fname && subFileName(this.fname) || '';
    },
    icon: function icon() {
      return this.fname && getFileIcon(this.fname, this.metadata.ftype) || '';
    }
  },
  beforeCreate: function beforeCreate() {
    this.abort = function () {};
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var _yield$fetchFileMetad, fileinfo;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return fetchFileMetadata(_this.id[0]);
          case 2:
            _yield$fetchFileMetad = _context.sent;
            fileinfo = _yield$fetchFileMetad.fileinfo;
            _this.metadata = fileinfo;
            _this.$emit('propsChange', {});
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  methods: {
    onClose: function onClose() {
      this.$emit('close');
    },
    onSubmit: function onSubmit(formdata) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var sameTeam, needSecure, _yield$getSecureStatu, data, _yield$getSecureTeam, _data, res;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              sameTeam = formdata.groupid === _this2.metadata.groupid;
              needSecure = false;
              if (!(_this2.secureTeam && !sameTeam)) {
                _context2.next = 8;
                break;
              }
              _context2.next = 5;
              return getSecureStatus(_this2.metadata.groupid, _this2.id);
            case 5:
              _yield$getSecureStatu = _context2.sent;
              data = _yield$getSecureStatu.data;
              needSecure = data.length > 0;
            case 8:
              if (!(!sameTeam && !needSecure)) {
                _context2.next = 20;
                break;
              }
              _context2.prev = 9;
              _context2.next = 12;
              return getSecureTeam(_this2.metadata.groupid);
            case 12:
              _yield$getSecureTeam = _context2.sent;
              _data = _yield$getSecureTeam.data;
              if (_data && _data.init_decode_status === 0) {
                needSecure = true;
              }
              _context2.next = 20;
              break;
            case 17:
              _context2.prev = 17;
              _context2.t0 = _context2["catch"](9);
              console.log(_context2.t0);
            case 20:
              if (_this2.secureTeam && _this2.hasFolder && !sameTeam) {
                needSecure = true;
              }
              if (!(!sameTeam && needSecure)) {
                _context2.next = 32;
                break;
              }
              _context2.prev = 22;
              _context2.next = 25;
              return getSecureTeam(formdata.groupid);
            case 25:
              res = _context2.sent;
              if (res.data && res.data.secure_switch === 1) {
                needSecure = false;
              }
              _context2.next = 32;
              break;
            case 29:
              _context2.prev = 29;
              _context2.t1 = _context2["catch"](22);
              console.log(_context2.t1);
            case 32:
              needSecure ? _this2.onDecrypt(formdata) : _this2.onMove(formdata);
            case 33:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[9, 17], [22, 29]]);
      }))();
    },
    onMove: function onMove(data) {
      var _arguments = arguments,
        _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var decrypt, id, groupid, formdata, _yield$moveFile, _data2, _ref, xResponse, _ref2, _data3, _ref3, faillist, _e$response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              decrypt = _arguments.length > 1 && _arguments[1] !== undefined ? _arguments[1] : false;
              id = data.id, groupid = data.groupid;
              if (!_this3.processing) {
                _context3.next = 4;
                break;
              }
              return _context3.abrupt("return");
            case 4:
              _this3.processing = true;
              _context3.prev = 5;
              formdata = {
                fileids: _this3.id,
                groupid: _this3.metadata.groupid,
                parentid: _this3.metadata.parentid,
                target_groupid: groupid,
                target_parentid: id,
                decrypt: decrypt
              };
              _context3.next = 9;
              return moveFile(formdata);
            case 9:
              _yield$moveFile = _context3.sent;
              _data2 = _yield$moveFile.data;
              _context3.next = 13;
              return batchProgress(_this3.metadata.groupid, {
                id: _this3.id.join(','),
                groupid: _this3.metadata.groupid,
                parentid: _this3.metadata.parentid,
                taskid: _data2.taskid,
                decrypt: decrypt,
                desc: 'moveFile',
                cancel: function cancel(c) {
                  _this3.abort = c;
                }
              });
            case 13:
              _this3.metadata = merge(_this3.metadata, {
                groupid: groupid,
                parentid: id
              });
              _this3.$emit('close', 'ok', {
                formdata: formdata,
                file: _this3.metadata,
                taskid: _data2.taskid
              });
              Message.success(t('logic.FileMove.txt3'));
              _context3.next = 24;
              break;
            case 18:
              _context3.prev = 18;
              _context3.t0 = _context3["catch"](5);
              _ref = _context3.t0 || {}, xResponse = _ref.xResponse;
              _ref2 = xResponse || {}, _data3 = _ref2.data;
              _ref3 = _data3 || {}, faillist = _ref3.faillist;
              if (faillist && faillist.length) {
                Message.error({
                  type: 'error',
                  message: (_context3.t0 === null || _context3.t0 === void 0 || (_e$response = _context3.t0.response) === null || _e$response === void 0 || (_e$response = _e$response.data) === null || _e$response === void 0 || (_e$response = _e$response.faillist[0]) === null || _e$response === void 0 ? void 0 : _e$response.msg) || ''
                });
              } else {
                Message.error({
                  type: 'error',
                  message: (_data3 === null || _data3 === void 0 ? void 0 : _data3.msg) || ''
                });
              }
            case 24:
              _this3.processing = false;
            case 25:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[5, 18]]);
      }))();
    },
    onDecrypt: function onDecrypt(data) {
      var _this4 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var res, options;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return checkteamCreator(_this4.metadata.groupid);
            case 2:
              res = _context4.sent;
              options = {
                title: '移动',
                onSecureCallback: function onSecureCallback(decrypt) {
                  _this4.onMove(data, decrypt);
                },
                isTeamCreator: res.result,
                actionType: 'move'
              };
              _this4.$emit('change', 'KSecureTeamTips', options);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    }
  }
};

FileMove.install = function (Vue) {
  Vue.component(FileMove.name, FileMove);
};

export { FileMove as default };
